<template>
    <v-layout>
        <v-dialog v-model="infoDialog" width="auto">
            <v-card class="pa-3">
                <v-card-text class="font16 pa-2">{{ message }}</v-card-text>

                <v-card-actions class="pr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn tag="a" color="lightBlack" text @click="infoDialog = false">
                        {{ $t('action.ok') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog scrollable persistent v-model="dialogUploadDocuments" width="500" :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card class="pa-3">
                <v-card-title class="pt-2 pl-1 pb-1 pl-7">
                    <span class="text-h5">{{ $t('menu.verification') }}</span>
                    <v-spacer></v-spacer>
                    <v-btn tag="a" icon @click="dialogUploadDocuments = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="">
                    <AppForm ref="uploadDocumentsForm" @keyup.native.enter="uploadDocuments" class="pl-4 pr-4">
                        <v-container class="pl-0 pr-0">
                            <v-row>
                                <v-col cols="12" class="pl-2 pr-2 pt-0 pb-0">
                                    <span class="font14 bold">
                                        {{ $t('menu.verificationOfYourAccount') }}
                                    </span>
                                    <br />
                                    <br />
                                    <span class="font14">
                                        {{ $t('menu.verificationText') }}
                                    </span>
                                    <br />
                                    <br />
                                    <span class="font14">
                                        {{ $t('menu.labelDocuments') }}
                                    </span>
                                    <br />
                                    <br />
                                    <div class="pl-4 font13 pb-4" v-if="!isValidId">
                                        <span class="bold">
                                            {{ $t('menu.idDocument') }}
                                        </span>
                                        <span>
                                            {{ $t('menu.labelIdDocument') }}
                                        </span>
                                        <v-file-input
                                            show-size
                                            :hint="$t('menu.allowedTypes')"
                                            persistent-hint
                                            class=""
                                            v-model="idDocument"
                                            :label="$t('menu.idDocument')"
                                            accept="image/png, image/jpeg, application/pdf"
                                            truncate-length="35"
                                            :rules="rules.file"
                                            require
                                        ></v-file-input>
                                    </div>
                                    <div class="pl-4 font13 pb-4" v-if="!isValidUtility">
                                        <span class="bold">
                                            {{ $t('menu.utilityDocument') }}
                                        </span>
                                        <span>
                                            {{ $t('menu.labelUtilityDocument') }}
                                        </span>
                                        <v-file-input
                                            show-size
                                            :hint="$t('menu.allowedTypes')"
                                            persistent-hint
                                            class=""
                                            v-model="utilityDocument"
                                            :label="$t('menu.utilityDocument')"
                                            accept="image/png, image/jpeg, application/pdf"
                                            truncate-length="35"
                                            :rules="rules.file"
                                            require
                                        ></v-file-input>
                                    </div>
                                    <span class="font14">
                                        {{ $t('menu.reviewText') }}
                                    </span>
                                </v-col>
                                <div class="pl-2 pr-2 pt-2 pb-0 upload-error" v-show="isError">
                                    <span>{{ message }}</span>
                                </div>
                            </v-row>
                        </v-container>
                    </AppForm>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn tag="a" :loading="loading" :disabled="loading" color="tbGreen" style="color: white" elevation="0" @click="uploadDocuments">
                        <span class="bold">
                            {{ $t('action.submitVerification') }}
                        </span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<style scoped>
    .upload-error span {
        font-size: 12px;
        color: #ef3b3a;
    }
</style>
<script>
    import AppForm from 'Pages/core/form/AppForm';
    import { mapGetters } from 'vuex';
    import store from '~/store';

    export default {
        name: 'app-menuAccountUploadDocumentsDialog',
        components: {
            AppForm,
        },

        data() {
            return {
                dialogUploadDocuments: false,
                infoDialog: false,
                idDocument: null,
                utilityDocument: null,
                isValidUtility: false,
                isValidId: false,
                loading: false,
                isError: false,
                message: '',

                rules: {
                    file: [
                        (v) => !!v || store.$i18n.t('rules.required'),
                        (v) => {
                            const allowedTypes = ['image/png', 'image/jpeg', 'application/pdf'];
                            if (v && !allowedTypes.includes(v.type)) {
                                return store.$i18n.t('rules.fileAllowedTypes');
                            }
                            return true;
                        },
                        (v) => {
                            if (v && v.size > 3 * 1024 * 1024) {
                                return store.$i18n.t('rules.fileSize', {
                                    size: 3,
                                });
                            }
                            return true;
                        },
                    ],
                },
            };
        },

        created: function () {
            console.log('Component %s was created.', this.$options.name);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {
            open() {
                if (this.$refs.uploadDocumentsDialog) {
                    this.$refs.uploadDocumentsDialog.$refs.form.reset();
                    this.$refs.uploadDocumentsDialog.$refs.form.resetValidation();
                }
                this.depositAndWithdrawals();
            },
            depositAndWithdrawals() {
                this.$store.dispatch('UserModule/checkDocuments').then((response) => {
                    let data = response.data;

                    if (data.success) {
                        if (data.is_id_proof && data.is_utility_proof) {
                            //to fix blocked popup in mac safari
                            setTimeout(() => {
                                window.open(
                                    'https://payments.tradeball.com/?token=' + this.$store.getters['UserModule/getToken'] + '&lang=' + this.$store.$i18n.locale,
                                    '_blank'
                                );
                            });
                        } else if ((!data.is_id_proof && !data.is_valid_id) || (!data.is_utility_proof && !data.is_valid_utility)) {
                            this.isValidUtility = data.is_utility_proof || data.is_valid_utility;
                            this.isValidId = data.is_id_proof || data.is_valid_id;
                            this.dialogUploadDocuments = true;
                        } else {
                            this.infoDialog = true;
                            this.message = this.$t('menu.approvalMessage');
                        }
                    }
                });
            },
            uploadDocuments() {
                let form = this.$refs.uploadDocumentsForm.$refs.form;

                let validationResult = form.validate();
                if (validationResult) {
                    let self = this;
                    this.loading = true;
                    let formData = new FormData();
                    formData.append('idDocument', this.idDocument ? this.idDocument : '');
                    formData.append('utilityDocument', this.utilityDocument ? this.utilityDocument : '');

                    this.$store
                        .dispatch('UserModule/uploadDocuments', formData)
                        .then((response) => {
                            if (response.data.success) {
                                this.dialogUploadDocuments = false;
                                this.infoDialog = true;
                                this.message = this.$t(response.data.message);
                            } else {
                                this.isError = true;
                                this.message = this.$t(response.data.message);
                            }
                            this.idDocument = null;
                            this.utilityDocument = null;
                            this.loading = false;

                            form.reset();
                            form.resetValidation();
                        })
                        .catch(function (error) {
                            self.isError = true;
                            self.message = self.$t('common.uploadFailed');

                            if (error.includes('413 Request Entity Too Large')) {
                                self.message = self.$t('user.maxFileSize');
                            }
                            self.loading = false;

                            form.reset();
                            form.resetValidation();
                        });
                }
            },
        },

        computed: {
            ...mapGetters({}),

            user() {
                return this.$store.getters['UserModule/getUser'];
            },
        },
    };
</script>
